import { render, staticRenderFns } from "./CustomersMeili.vue?vue&type=template&id=0fff8042"
import script from "./CustomersMeili.vue?vue&type=script&lang=js"
export * from "./CustomersMeili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports